export default "__VITE_ASSET__DKr6qhHl__"